import {StyleSheet} from 'react-native';

import {indent, screenWidth} from '/constant/layout.constant';
import {cloudLight, denim, onyx, white} from '/theme/color/on.color';
import {alto, codGray, mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginVertical: indent * 0.75,
  },
  link: {
    color: denim,
    fontWeight: '600',
  },
  headerContainer: {
    marginBottom: 10,
    flexDirection: 'row',
  },
  headerContainerLargeFont: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  headerText: {
    flex: 1,
    color: codGray,
  },
  sideText: {
    color: mineShaft,
  },
  sideTextLargeFont: {
    width: '100%',
    marginTop: indent * 0.15,
  },
  BBBContent: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: cloudLight,
    backgroundColor: white,
    padding: 16,
    marginRight: 0,
    alignSelf: 'stretch',
    marginBottom: 15,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    minHeight: 370,
  },

  profileCardContent: {
    borderWidth: 1,
    borderRadius: 8,
    padding: 16,
    borderColor: alto,
    backgroundColor: white,
    elevation: 10,
    shadowColor: onyx,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.15,
    shadowRadius: 10,
    alignSelf: 'center',
    width: screenWidth() - indent * 2,
    marginVertical: indent + 10,
    paddingTop: indent,
  },
  progressBarContainerOneLine: {
    width: 50,
    marginRight: 20,
    backgroundColor: cloudLight,
  },
});
